import { useEffect } from 'react';

import {
  type ModelMessageTemplate,
  useSearchMutation,
} from '@app/api/MessageTemplates';
import { FRONT_WARNING } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';

type MessageTemplatesRegistryEffectsArgs = {
  pageSize: number;
  setTemplates: (templates: ModelMessageTemplate[]) => void;
  setSearchId: (val: number) => void;
  setRowsTotal: (val: number) => void;
};

export const useMessageTemplatesRegistryEffects = ({
  pageSize,
  setTemplates,
  setSearchId,
  setRowsTotal,
}: MessageTemplatesRegistryEffectsArgs) => {
  const { showNotification } = useNotification();

  const { activeBranchId, userId, database } = useUserPrint();

  const [searchMessagesTemplates, { isLoading }] = useSearchMutation();

  useEffect(() => {
    if (!activeBranchId) {
      return showNotification(
        'Идентификатор активного филиала не найден',
        FRONT_WARNING
      );
    }

    const fetchInitialTemplates = async () => {
      try {
        const { Id, MessageTemplates, CountMessageTemplates } =
          await searchMessagesTemplates({
            ActiveBranchId: activeBranchId,
            data: {
              SearchTerm: '',
              MessageTemplatesPerPage: pageSize,
            },
          }).unwrap();

        setSearchId(Id);
        setRowsTotal(CountMessageTemplates);
        setTemplates(MessageTemplates || []);
      } catch (err) {
        showNotification(err);
      }
    };

    fetchInitialTemplates();
  }, [
    activeBranchId,
    pageSize,
    showNotification,
    searchMessagesTemplates,
    setTemplates,
    setSearchId,
    setRowsTotal,
    userId,
    database,
  ]);

  return {
    isLoading,
  };
};
